export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"}],"link":[{"rel":"preload","as":"style","href":"https://use.typekit.net/etg3uhr.css","onload":"this.onload=null;this.rel='stylesheet'"},{"rel":"stylesheet","href":"https://use.typekit.net/etg3uhr.css","media":"print","onload":"this.media='all'"}],"style":[],"script":[{"src":"https://kit.fontawesome.com/3b51b55d1b.js","crossorigin":"anonymous","data-search-pseudo-elements":true,"defer":true},{"src":"https://www.google.com/recaptcha/api.js?render=6LehFV4rAAAAADJ_cPV8sJoRPWSqgI95WQ6b7bIB","async":true,"defer":true},{"children":"(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src=\"https://www.clarity.ms/tag/\"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window, document, \"clarity\", \"script\", \"pcs66g7fju\");"}],"noscript":[{"children":"<link rel=\"stylesheet\" href=\"https://use.typekit.net/etg3uhr.css\">"}],"htmlAttrs":{"lang":"en"},"title":"Holgates Holiday Parks in Cumbria"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false